var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor send-email" },
    [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "title" }, [_vm._v("From:")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c(
              "a-select",
              {
                attrs: { defaultValue: null },
                model: {
                  value: _vm.clone.from,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "from", $$v)
                  },
                  expression: "clone.from",
                },
              },
              [
                _c(
                  "a-select-option",
                  { attrs: { selected: true, value: "null" } },
                  [_vm._v("👉Select Email Sender...")]
                ),
                _vm._v(" "),
                _vm._l(_vm.senderMailAddresses, function (senderMailAddress) {
                  return _c(
                    "a-select-option",
                    {
                      key: senderMailAddress.mail,
                      attrs: { value: senderMailAddress.mail },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(senderMailAddress.mail) +
                          "\n                "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "title" }, [_vm._v("To:")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "to mail address",
                "show-attributes": true,
                "show-emoji": false,
              },
              model: {
                value: _vm.clone.to,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "to", $$v)
                },
                expression: "clone.to",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "title" }, [_vm._v("Mail İçeriği:")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c(
              "a-select",
              {
                attrs: { defaultValue: null },
                model: {
                  value: _vm.clone.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "type", $$v)
                  },
                  expression: "clone.type",
                },
              },
              [
                _c("a-select-option", { attrs: { value: "custom" } }, [
                  _vm._v(" Custom"),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "template" } }, [
                  _vm._v("Özel Şablon"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.clone.type === "template"
        ? [
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "title" }, [_vm._v("Mail Şablonu:")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-editor-wrapper" },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { defaultValue: null },
                      model: {
                        value: _vm.clone.templateId,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "templateId", $$v)
                        },
                        expression: "clone.templateId",
                      },
                    },
                    [
                      _c(
                        "a-select-option",
                        { attrs: { selected: true, value: "null" } },
                        [_vm._v("👉Select Email Template...")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.templates, function (template) {
                        return _c(
                          "a-select-option",
                          { key: template.id, attrs: { value: template._id } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(template.name) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.clone.templateId &&
            _vm.clone.templateId !== "null" &&
            _vm.templateParamsForUi.length
              ? _vm._l(_vm.templateParamsForUi, function (row, idx) {
                  return _c(
                    "div",
                    {
                      key: "tpl-param-" + row.param + "-" + idx,
                      staticClass: "wrapper template-param-row",
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("Şablon parametresi: " + _vm._s(row.param)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-editor-wrapper" },
                        [
                          _c("TiptapEditor", {
                            attrs: {
                              placeholder: "Değer veya özellik seçin",
                              "show-attributes": true,
                              "show-emoji": false,
                            },
                            model: {
                              value: row.value,
                              callback: function ($$v) {
                                _vm.$set(row, "value", $$v)
                              },
                              expression: "row.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.type === "custom"
        ? [
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "title" }, [_vm._v("Subject:")]),
              _vm._v(" "),
              _c("div", { staticClass: "text-editor-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.clone.subject,
                      expression: "clone.subject",
                    },
                  ],
                  staticStyle: { border: "none", padding: "5px" },
                  attrs: { type: "text", placeholder: "Subject" },
                  domProps: { value: _vm.clone.subject },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.clone, "subject", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "title" }, [_vm._v("Content:")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-editor-wrapper" },
                [
                  _c("TiptapEditor", {
                    attrs: {
                      placeholder: "to mail address",
                      "show-attributes": true,
                      "show-emoji": false,
                    },
                    model: {
                      value: _vm.clone.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "content", $$v)
                      },
                      expression: "clone.content",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }